import React from "react";

// The banner at the top of a public page: a photo under a white wash, with the
// page's name and a short introduction in dark text.
//   <PageHero photo={photo} eyebrow="Features" title="...">Introduction</PageHero>
function PageHero({ photo, eyebrow, title, children }) {
    return (
        <section className="cf-page-hero">
            {photo && <img className="cf-hero-photo" src={photo} alt="" />}
            <div className="cf-hero-shade"></div>
            <div className="cf-wrap">
                <div className="cf-hero-text">
                    {eyebrow && <span className="cf-pill"><span className="cf-pulse"></span> {eyebrow}</span>}
                    <h1>{title}</h1>
                    {children && <p className="cf-lede">{children}</p>}
                </div>
            </div>
        </section>
    );
}

export default PageHero;
